import React from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";
import logo from "../assets/logo.svg";

const Loader = ({ size = 120 }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "rgba(255, 255, 255, 0.0)", // fully transparent
        backdropFilter: "blur(6px)",         // blur background
        WebkitBackdropFilter: "blur(6px)",   // Safari support
        zIndex: 1300,
      }}
    >
      <Box sx={{ position: "relative", width: size, height: size }}>
        {/* Animated Ring */}
        <motion.div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: size,
            height: size,
            borderRadius: "50%",
            border: "4px solid rgba(255, 255, 255, 0.2)",
            borderTopColor: "#d41414",
          }}
          animate={{ rotate: 360 }}
          transition={{
            repeat: Infinity,
            duration: 1.5,
            ease: "linear",
          }}
        />

        {/* Centered Company Logo */}
        <motion.img
          src={logo}
          alt="Company Logo"
          style={{
            width: "70%",
            height: "70%",
            objectFit: "contain",
            borderRadius: "12px",
            position: "absolute",
            top: "15%",
            left: "15%",
          }}
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.8, 1, 0.8],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      </Box>
    </Box>
  );
};

export default Loader;
